// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] || chunkId) + "." + {"241":"6860c091","334":"b2f92386","444":"106b435d","522":"8f26b516","554":"f87f1b00","641":"3c1fe257"}[chunkId] + ".chunk.css";
};